import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BlockOffer} from '../../phonenumber/phonenumber.model';

@Component({
    selector: 'app-select-phonenumber',
    templateUrl: './select-phonenumber.component.html',
    standalone: false
})
export class SelectPhonenumberComponent implements OnInit {

  @Output() selected: EventEmitter<Map<string, boolean>> = new EventEmitter<Map<string, boolean>>();
  @Input() blocks: BlockOffer[];
  @Input() maxAllowedAcquiredNumbers: number;

  selectedPhonenumbers: Map<string, boolean> = new Map<string, boolean>();

  constructor() {
  }

  ngOnInit() {
    if(this.maxAllowedAcquiredNumbers === -1 || this.maxAllowedAcquiredNumbers > this.blocks.length) {
      this.maxAllowedAcquiredNumbers = this.blocks.length;
    }
  }

  public onPhonenumberBlockToggled(event: {id: string; selected: boolean}) {
    if (!event.selected) {
      this.selectedPhonenumbers.delete(event.id);
      return;
    }

    if (this.selectedPhonenumbers.size >= this.maxAllowedAcquiredNumbers) {
      return;
    }

    this.selectedPhonenumbers.set(event.id, true);
  }

  public select() {
    this.selected.emit(this.selectedPhonenumbers);
  }

}
